var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"sticky-footer"},[_c('div',{staticClass:"container my-auto"},[(_vm.showCopyright)?_c('div',{staticClass:"copyright text-center my-auto"}):_vm._e()])])}
var staticRenderFns = []

export { render, staticRenderFns }